import {
  Card,
  CardContent,
  CardHeader,
  CardTitle,
} from '@repo/ui/components/card';
import { createFileRoute, Link } from '@tanstack/react-router';
import { ArrowLeft, Calendar, Crown, Gift } from 'lucide-react';

import { LoadingState, PageContainer, PageHeader } from '@/components/shared';
import { useUserMe } from '@/hooks/queries/use-user-me';

export const Route = createFileRoute('/(app)/account/plan')({
  component: PlanPage,
});

const PLAN_LIMITS = {
  free: {
    maxWishlistItems: 3,
    maxOccasions: 3,
  },
  pro: {
    maxWishlistItems: Infinity,
    maxOccasions: Infinity,
  },
};

function PlanPage() {
  const { data, isLoading } = useUserMe();

  if (isLoading) {
    return (
      <PageContainer>
        <LoadingState message="Carregando..." />
      </PageContainer>
    );
  }

  const plan = data?.plan ?? 'free';
  const planName = plan === 'pro' ? 'Pro' : 'Gratuito';
  const limits =
    PLAN_LIMITS[plan as keyof typeof PLAN_LIMITS] ?? PLAN_LIMITS.free;

  return (
    <PageContainer>
      <div className="space-y-6">
        <PageHeader
          title="Meu Plano"
          actions={
            <Link
              to="/account"
              className="text-muted-foreground hover:text-foreground flex items-center gap-1 text-sm"
            >
              <ArrowLeft className="h-4 w-4" />
              Voltar
            </Link>
          }
        />

        <Card>
          <CardHeader>
            <CardTitle className="flex items-center gap-2">
              <Crown className="text-primary h-5 w-5" />
              Plano {planName}
            </CardTitle>
          </CardHeader>
          <CardContent>
            <div className="space-y-4">
              <div className="flex items-center justify-between">
                <div className="flex items-center gap-2">
                  <Gift className="text-muted-foreground h-4 w-4" />
                  <span className="text-foreground">Presentes na wishlist</span>
                </div>
                <span className="text-muted-foreground">
                  {limits.maxWishlistItems === Infinity
                    ? 'Ilimitado'
                    : `Até ${limits.maxWishlistItems}`}
                </span>
              </div>

              <div className="flex items-center justify-between">
                <div className="flex items-center gap-2">
                  <Calendar className="text-muted-foreground h-4 w-4" />
                  <span className="text-foreground">Ocasiões especiais</span>
                </div>
                <span className="text-muted-foreground">
                  {limits.maxOccasions === Infinity
                    ? 'Ilimitado'
                    : `Até ${limits.maxOccasions}`}
                </span>
              </div>
            </div>
          </CardContent>
        </Card>

        {plan === 'free' && (
          <Card className="border-primary/20 bg-primary/5">
            <CardContent className="pt-6">
              <p className="text-muted-foreground text-sm">
                Faça upgrade para o plano Pro e tenha acesso ilimitado a todos
                os recursos.
              </p>
            </CardContent>
          </Card>
        )}
      </div>
    </PageContainer>
  );
}
